/**
 * Tour de France 2026 – Owl Carousel Sliders
 *
 * All carousel initializations in one place.
 */

/* global jQuery */

(function ($) {
    'use strict';

    function initSliders() {
        if (!$.fn.owlCarousel) {
            $(window).on('load', function () {
                initSliders();
            });
            return;
        }

        // ── People slider: .tdf26-os-people__inner ──
        // Infinite, dots only, responsive 1/2/3 items
        var navSvgRight = '<svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none"><circle cx="31" cy="31" r="31" transform="matrix(-1 0 0 1 62 0)" fill="#007A33"/><path d="M25 18.5L37.5 31L25 43.5" stroke="white" stroke-width="2"/></svg>';
        var navSvgLeft = '<svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none" style="transform:scaleX(-1)"><circle cx="31" cy="31" r="31" transform="matrix(-1 0 0 1 62 0)" fill="#007A33"/><path d="M25 18.5L37.5 31L25 43.5" stroke="white" stroke-width="2"/></svg>';

        $('.tdf26-os-people__inner').each(function () {
            $(this).addClass('owl-carousel').owlCarousel({
                loop: true,
                nav: true,
                navText: [navSvgLeft, navSvgRight],
                dots: true,
                margin: 20,
                responsive: {
                    0:    { items: 1 },
                    600:  { items: 2 },
                    1024: { items: 3 }
                }
            });
        });

        // ── Tickets listing: .tdf26-tickets-listing ──
        // 1 item on mobile (carousel), 2 items on desktop (grid-like, no drag)
        /* $('.tdf26-tickets-listing').each(function () {
            $(this).addClass('owl-carousel').owlCarousel({
                loop: false,
                nav: false,
                dots: true,
                mouseDrag: true,
                touchDrag: true,
                margin: 50,
                responsive: {
                    0:    { items: 1 },
                    1024: { items: 2, dots: false, mouseDrag: false, touchDrag: false }
                }
            });
        }); */

        // ── Single-item slider: .tdf26-slide ──
        // Infinite, dots only, 1 item per row
        $('.tdf26-slider').each(function () {
            $(this).addClass('owl-carousel').owlCarousel({
                loop: true,
                nav: true,
                dots: true,
                items: 1,
                navText: [navSvgLeft, navSvgRight],
            });
        });

        // ── Pick-a-side: .tdf26-bingo-sides (mobile only) ──
        // On < 768px the two cards become a swipeable carousel with the next
        // card peeking (stagePadding); on desktop it stays the plain flex row.
        var $sides = $('.tdf26-bingo-sides');

        function buildSidesSlider() {
            if ($sides.hasClass('owl-loaded')) {
                // Already built but possibly sized while hidden → re-measure.
                $sides.trigger('refresh.owl.carousel');
                return;
            }
            $sides.addClass('owl-carousel').owlCarousel({
                items: 1,
                loop: false,
                nav: false,
                dots: true,
                margin: 16,
                stagePadding: 40,
                mouseDrag: true,
                touchDrag: true
            });
        }

        function destroySidesSlider() {
            if ($sides.hasClass('owl-loaded')) {
                $sides.trigger('destroy.owl.carousel');
                $sides.removeClass('owl-carousel owl-loaded owl-hidden owl-drag');
            }
        }

        function syncSidesSlider() {
            if (!$sides.length) { return; }
            if (window.matchMedia('(max-width: 767px)').matches) {
                buildSidesSlider();
            } else {
                destroySidesSlider();
            }
        }

        // Toggle on breakpoint changes. Also (re)build + refresh when the modal
        // opens, since owl can only size itself once the container is visible.
        // Namespaced + off/on so the handlers are not double-bound if
        // initSliders() runs again on window load.
        $(window).off('resize.tdfsides').on('resize.tdfsides', syncSidesSlider);
        $(document).off('click.tdfsides').on('click.tdfsides', '[data-tdf-bingo]', function () {
            setTimeout(syncSidesSlider, 250);
        });

        syncSidesSlider();

        // "Start over" reloads with #bingo and reopens the modal without a
        // click — refresh once the (now visible) modal has rendered.
        if (window.location.hash === '#bingo') {
            $(window).on('load', function () { setTimeout(syncSidesSlider, 300); });
        }

        // ── Rounds switcher: .rounds (mobile only, < 640px) ──
        // Below 640px the round stepper becomes a 2-up swipeable carousel — no
        // arrows, auto-positioned on the active round, with CUSTOM dots below: one
        // per round (4), since Owl's own pager only makes one per page (= 3 here).
        // The active dot mirrors the selected round; tapping a dot slides to + selects
        // that round. Desktop keeps the flex row. The <li.spacer> dividers must NOT
        // become slides → stripped before build / restored on destroy; the carousel
        // draws its own centre divider in CSS.
        var $rounds = $('.rounds');
        var $roundsDots = null;

        function setActiveRoundDot(i) {
            if ($roundsDots) {
                $roundsDots.children().removeClass('active').eq(i).addClass('active');
            }
        }

        function buildRoundsDots(total, activeIndex) {
            if ($roundsDots) { $roundsDots.remove(); }
            var dots = '';
            for (var i = 0; i < total; i++) {
                dots += '<li' + (i === activeIndex ? ' class="active"' : '') +
                    '><button type="button" aria-label="Round ' + (i + 1) + '"></button></li>';
            }
            $roundsDots = $('<ul class="rounds-dots">' + dots + '</ul>');
            $rounds.after($roundsDots);

            // Tap a dot → slide so that round is visible and select it. Triggering the
            // round link runs the prize switcher (main.js) and re-highlights the dot
            // via the click.tdfrounds handler below.
            $roundsDots.on('click', 'li', function () {
                var idx = $(this).index();
                if ($rounds.hasClass('owl-loaded')) {
                    $rounds.trigger('to.owl.carousel', [Math.min(idx, Math.max(0, total - 2)), 300]);
                }
                $rounds.find('li[data-round="' + (idx + 1) + '"] a').trigger('click');
            });
        }

        function restoreRoundsSpacers() {
            if (!$rounds.length) { return; }
            $rounds.find('.spacer').remove();
            $rounds.children('li[data-round]').each(function (i) {
                if (i > 0) { $(this).before('<li class="spacer"></li>'); }
            });
        }

        function buildRoundsSlider() {
            if (!$rounds.length || $rounds.hasClass('owl-loaded')) { return; }
            $rounds.find('.spacer').remove();                          // dividers can't be slides
            var total = $rounds.children('li[data-round]').length;     // 4
            var activeIndex = $rounds.children('li.active').index();   // 0-based among rounds
            if (activeIndex < 0) { activeIndex = 0; }
            var start = Math.min(activeIndex, Math.max(0, total - 2)); // clamp so round 4 → [3,4]
            $rounds.addClass('owl-carousel').owlCarousel({
                items: 2,
                slideBy: 1,
                loop: false,
                nav: false,
                dots: false,           // custom .rounds-dots below (one per round)
                margin: 0,
                mouseDrag: true,
                touchDrag: true,
                startPosition: start
            });
            buildRoundsDots(total, activeIndex);
        }

        function destroyRoundsSlider() {
            if (!$rounds.length || !$rounds.hasClass('owl-loaded')) { return; }
            $rounds.trigger('destroy.owl.carousel');
            $rounds.removeClass('owl-carousel owl-loaded owl-hidden owl-drag');
            if ($roundsDots) { $roundsDots.remove(); $roundsDots = null; }
            restoreRoundsSpacers();                                    // back to the desktop divider markup
        }

        function syncRoundsSlider() {
            if (!$rounds.length) { return; }
            if (window.matchMedia('(max-width: 639.98px)').matches) {
                buildRoundsSlider();
            } else {
                destroyRoundsSlider();
            }
        }

        // Keep the active dot in sync when a round is tapped directly (in or out of
        // the carousel). main.js swaps the prize list; here we just mirror the dot.
        $rounds.off('click.tdfrounds').on('click.tdfrounds', 'li[data-round] a', function () {
            var r = $(this).closest('li').data('round');
            if (r) { setActiveRoundDot(r - 1); }
        });

        $(window).off('resize.tdfrounds').on('resize.tdfrounds', syncRoundsSlider);
        syncRoundsSlider();
    }

    if ($('body').hasClass('tdf_2026')) {
        initSliders();
    }
})(jQuery);
